import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [footerSocial, setFooterSocial] = useState([]);
  const [footerCopyright, setFooterCopyright] = useState([]);
  const [logo, setLogo] = useState([]);
  const [footerAddress, setFooterAddress] = useState([]);
  const [isScrollVisible, setIsScrollVisible] = useState(false); // State for "Scroll to Top" button visibility

  // Fetch logo data
  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/logo`)
      .then((res) => res.json())
      .then((info) => setLogo(info));
  }, []);

  // Fetch footer address
  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/footer-address`)
      .then((res) => res.json())
      .then((info) => setFooterAddress(info));
  }, []);

  // Fetch social links
  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  // Fetch copyright
  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/copyrights`)
      .then((res) => res.json())
      .then((info) => setFooterCopyright(info));
  }, []);

  // Handle form submission for subscribers
  const handleSubscriber = (event) => {
    event.preventDefault();
    const subemail = event.target.subemail.value;

    const addItem = { subemail };

    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/add-subscriber`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(addItem),
    })
      .then((res) => res.json())
      .then(() => {
        alert("Subscription request sent successfully!");
      });
  };

  // Show "Scroll to Top" button when scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsScrollVisible(true);
      } else {
        setIsScrollVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (




    <>
      <footer className="footer">
        <div className="footer__wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <div className="footer__info">
                  {
                    logo.map(l => <div className="footer__info--logo">
                      <img src={l.logo} alt="image" />
                    </div>)
                  }
                  {
                    footerSocial.map(f => <div className="footer__info--content">
                      <p className="paragraph dark">
                        {f.aboutText}
                      </p>
                      <div className="social">
                        <ul>
                          <li className="facebook">
                            <a href={f.fblink}>
                              <i className="fab fa-facebook-f" />
                            </a>
                          </li>
                          <li className="twitter">
                            <a href={f.inslink}>
                              <i className="fab fa-instagram" />
                            </a>
                          </li>

                          <li className="youtube">
                            <a href={f.youlink}>
                              <i className="fab fa-youtube" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>)}
                </div>
              </div>
              <div className="col-lg-8">
                <div className="footer__content-wrapper">
                  <div className="footer__list">
                    <ul>
                      <li>Quick Links</li>
                      <li>
                        <a href="/">Home</a>
                      </li>
                      <li>
                        <a href="#services-sec">Services</a>
                      </li>
                      <li>
                        <a href="#pricing-sec">Pricing</a>
                      </li>
                     
                      <li>
                        <a href="#contact-sec">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                  <div className="footer__list">
                    {/* <ul>
                  <li>Help</li>
                  <li>
                    <a href="#">FAQ</a>
                  </li>
                  <li>
                    <a href="#">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="#">Support</a>
                  </li>
                  <li>
                    <a href="#">Terms of Service</a>
                  </li>
                  <li>
                    <a href="#">Contact</a>
                  </li>
                </ul> */}
                  </div>
                  {
                    footerAddress.map(a => <div className="download-buttons">
                      <h5>About Company</h5>
                      <p className="paragraph dark">
                        <i className="fas fa-envelope me-2" /> Email: {a.emailAddress}
                      </p>
                      <p className="paragraph dark">
                        <i className="fas fa-phone-alt  me-2" /> Phone: {a.phoneNumber}
                      </p>
                      <p className="paragraph dark">
                        <i className="fas fa-map-marker-alt  me-2" /> {a.location}
                      </p>
                    </div>)
                  }
                </div>
              </div>
            </div>
            <div className="row">
              {
                footerCopyright.map(f => <div className="footer__copy">
                  <h6>©{f.copyrightText}</h6>
                </div>)}
            </div>
            {/* Scroll to Top Button */}
            {isScrollVisible && (
              <button
                className="btn position-fixed bottom-0 end-0 m-3"
                onClick={scrollToTop}
                style={{
                  zIndex: 1000,
                  backgroundColor: '#F5207A',  // Red color for the button
                  borderRadius: '50%',         // Make the button fully round
                  padding: '20px',              // Adjust padding for appropriate size
                  color: 'white',              // White text color for contrast
                  border: 'none',              // Remove border
                  fontSize: '15px',            // Make text size appropriate and readable
                  fontWeight: 'bold',          // Bold text for better visibility
                  boxShadow: '0 4px 6px hsla(0, 0.00%, 0.00%, 0.10)',  // Add subtle shadow for modern look
                  cursor: 'pointer',          // Pointer cursor to indicate it's clickable
                  transition: 'all 0.3s ease', // Smooth transition on hover
                  width: '60px',              // Ensure the button has a fixed width
                  height: '60px',             // Ensure the button has a fixed height (making it a perfect circle)
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'scale(1.1)'; // Button scale on hover
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'scale(1)';   // Revert button scale when hover ends
                }}
              >
                ↑
              </button>
            )}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
